import { createSlice } from '@reduxjs/toolkit';

export interface ConstructionSchedule {
  kickoffMeeting: string;
  mobilization: string;
  fiftyCompletion: string;
  seventyFiveCompletion: string;
  constructionCompletion: string;
}

const initialState: ConstructionSchedule = {
  kickoffMeeting: '',
  mobilization: '',
  fiftyCompletion: '',
  seventyFiveCompletion: '',
  constructionCompletion: '',
};

export const ConstructionScheduleSlice = createSlice({
  name: 'constructionScheduleSliceInfo',
  initialState,
  reducers: {
    setConstructionSchedule(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setConstructionSchedule } = ConstructionScheduleSlice.actions;

export default ConstructionScheduleSlice.reducer;
